import { create } from 'zustand'
import { combine, persist } from 'zustand/middleware'

import subscribeToStore from '@/lib/zustand'

export type MenuStoreType = {
  isMobileMenuOpen: boolean
  isDesktopNavCollapsed: boolean
}

export const INITIAL_MENU_STORE_VALUE: MenuStoreType = {
  isMobileMenuOpen: false,
  isDesktopNavCollapsed: false,
}

let collapseTimeout: ReturnType<typeof setTimeout> | null = null

const MENU_STORAGE_KEY = 'menu'
const menuStore = subscribeToStore(
  create(
    persist(
      combine(INITIAL_MENU_STORE_VALUE, (set, get) => ({
        toggleMobileMenu: () => {
          const isOpen = get().isMobileMenuOpen
          set({ isMobileMenuOpen: !isOpen })
        },
        closeMobileMenu: () => {
          set({ isMobileMenuOpen: false })
        },
        openMobileMenu: () => {
          set({ isMobileMenuOpen: true })
        },
        toggleDesktopNavCollapsed: () => {
          const isCollapsed = get().isDesktopNavCollapsed

          if (collapseTimeout) {
            clearTimeout(collapseTimeout)
          }
          const layout = document.querySelector<HTMLDivElement>('.main-layout')!
          layout.classList.add('js-nav-collapsed--is-transitioning')
          layout.classList.toggle('js-nav-collapsed')
          set({ isDesktopNavCollapsed: !isCollapsed })

          collapseTimeout = setTimeout(() => {
            layout.classList.remove('js-nav-collapsed--is-transitioning')
          }, 500)
        },
      })),
      {
        name: MENU_STORAGE_KEY,
      },
    ),
  ),
)

export default menuStore
